module.exports = __webpack_public_path__ + "media/images/athletes/2881-d16bdf92189510e3fb101bbbb1ac4915.png";